import type { Bid } from 'src/app/types';

export interface Default extends Partial<Bid> {
    buyer: {
        organizationKey: string;
        ownerKey: string;
        description?: string;
        financeOptionCode?: NonNullable<Bid['buyer']['financeOptionCode']>;
    };
}

export const DEFAULT: Default = {
    buyer: {
        description: undefined,
        financeOptionCode: undefined,
        organizationKey: '',
        ownerKey: '',
    },
};